import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GroupGlobalPermissions, UserGlobalPermissions } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class GlobalPrivilegesResource {
  private _http = inject(HttpClient);

  getUsers(): Observable<UserGlobalPermissions[]> {
    return this._http.get<UserGlobalPermissions[]>(`/services/microsoft/admin/global-permissions/users`);
  }

  postUser(user: UserGlobalPermissions): Observable<UserGlobalPermissions> {
    return this._http.post<UserGlobalPermissions>(`/services/microsoft/admin/global-permissions/users`, user);
  }

  putUser(user: UserGlobalPermissions): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/admin/global-permissions/users/${encodeURIComponent(user.upn)}`,
      user,
    );
  }

  deleteUser(upn: string): Observable<void> {
    return this._http.delete<void>(`/services/microsoft/admin/global-permissions/users/${encodeURIComponent(upn)}`);
  }

  getGroups(): Observable<GroupGlobalPermissions[]> {
    return this._http.get<GroupGlobalPermissions[]>(`/services/microsoft/admin/global-permissions/groups`);
  }

  postGroup(group: GroupGlobalPermissions): Observable<GroupGlobalPermissions> {
    return this._http.post<GroupGlobalPermissions>(`/services/microsoft/admin/global-permissions/groups`, group);
  }

  putGroup(group: GroupGlobalPermissions): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/admin/global-permissions/groups/tenant-guids/${group.groupTenantGuid}/display-names/${encodeURIComponent(group.displayName)}`,
      group,
    );
  }

  deleteGroup(groupTenantGuid: string, displayName: string): Observable<void> {
    return this._http.delete<void>(
      `/services/microsoft/admin/global-permissions/groups/tenant-guids/${groupTenantGuid}/display-names/${encodeURIComponent(displayName)}`,
    );
  }
}
